window.addEventListener('DOMContentLoaded', () => {
  document
    .querySelector('.close-continue-shopping-modal')
    .addEventListener('click', () => {
      document
        .querySelector('.continue-shopping-modal')
        .classList.add('hidden');
    });
  window.addEventListener('continue-shipping', (e) => {
    const detail = e.detail;
    document.querySelector('.preview_img').src = detail.image;
    document.querySelector('.quantity').innerHTML =
      `<p class="text-sm text-neutral-30">Quantity: <span class="text-neutral-60">${detail.quantity}</span></p>`;
    const variantEl = document.querySelector('.variant');
    Object.entries(detail.variants || {}).forEach(([key, value]) => {
      variantEl.innerHTML += `<p class="text-sm text-neutral-30">${key}: <span class="text-neutral-60">${value}</span></p>`;
    });
    document
      .querySelector('.continue-shopping-modal')
      .classList.remove('hidden');
  });
});
